import axios from "axios";

const api = axios.create();

api.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error),
);

export default api;
